const errorMessages = {
  100: "Sin Conexion",
  202: "Este nombre de usuario ya esta en uso.",
  203: "Este email ya esta en uso.",
  119: "No estas autorizado para realizar esta accion.",
  141: "Asegurate que tus datos estan correctos.",
};

export default errorMessages;
